export default "__VITE_ASSET__CiNw5w3G__"